module.exports = __webpack_public_path__ + "img/tiempoAsistencia.5f2032e2.png";